import AudioPlayer from './AudioPlayer';

export default AudioPlayer;
export * from './AudioPlayer';
